/* pagina de produto padrao no estilo novo (sections/nt-fx-produto.liquid): galeria e troca de variante.
   sem script a galeria continua sendo um trilho que desliza e a variante sai do <select name="id"> nativo. */
(function () {
  'use strict';
  if (customElements.get('nt-fx-produto')) return;

  var calmo = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  customElements.define(
    'nt-fx-produto',
    class extends HTMLElement {
      connectedCallback() {
        if (this.pronto) return;
        this.pronto = true;
        this.montarGaleria();
        this.montarVariantes();
      }

      /* ---------- galeria ---------- */
      montarGaleria() {
        var g = this.querySelector('[data-prod-galeria]');
        if (!g) return;
        this.trilho = g.querySelector('[data-prod-fotos]');
        this.fotos = Array.prototype.slice.call(this.trilho.querySelectorAll('[data-prod-foto]'));
        this.atual = 0;
        if (this.fotos.length < 2) return;

        var caixaMinis = g.querySelector('[data-prod-minis]');
        var setas = g.querySelectorAll('[data-prod-seta]');
        this.minis = caixaMinis ? Array.prototype.slice.call(caixaMinis.querySelectorAll('[data-prod-mini]')) : [];
        if (caixaMinis) caixaMinis.hidden = false;

        this.minis.forEach(function (b, i) {
          b.addEventListener('click', function () { this.irPara(i); }.bind(this));
        }, this);
        Array.prototype.forEach.call(setas, function (seta) {
          seta.hidden = false;
          seta.addEventListener('click', function () {
            this.irPara(this.atual + Number(seta.getAttribute('data-prod-seta')));
          }.bind(this));
        }, this);

        // quem arrasta o trilho (celular) tambem muda a miniatura marcada
        var espera;
        this.trilho.addEventListener('scroll', function () {
          clearTimeout(espera);
          espera = setTimeout(function () {
            var largura = this.trilho.clientWidth || 1;
            this.marcar(Math.round(this.trilho.scrollLeft / largura));
          }.bind(this), 80);
        }.bind(this), { passive: true });
      }

      irPara(i, instantaneo) {
        if (!this.fotos || this.fotos.length < 2) return;
        var n = this.fotos.length;
        i = ((i % n) + n) % n;
        this.trilho.scrollTo({ left: i * this.trilho.clientWidth, behavior: instantaneo || calmo ? 'auto' : 'smooth' });
        this.marcar(i);
      }

      marcar(i) {
        this.atual = i;
        (this.minis || []).forEach(function (b, k) {
          b.setAttribute('aria-pressed', k === i ? 'true' : 'false');
        });
      }

      irParaFoto(id, instantaneo) {
        if (!id || !this.fotos) return;
        for (var k = 0; k < this.fotos.length; k++) {
          if (this.fotos[k].getAttribute('data-prod-foto') === String(id)) {
            this.irPara(k, instantaneo);
            return;
          }
        }
      }

      /* ---------- variantes ---------- */
      montarVariantes() {
        var dados = this.querySelector('[data-prod-variantes]');
        var rotulos = this.querySelector('[data-prod-rotulos]');
        if (!dados || !rotulos) return;
        try {
          this.lista = JSON.parse(dados.textContent);
          this.rot = JSON.parse(rotulos.textContent);
        } catch (e) {
          return;
        }
        this.opcoes = this.querySelector('[data-prod-opcoes]');
        this.campo = this.querySelector('[data-prod-id]');
        if (!this.opcoes || !this.campo) return;

        var nativo = this.querySelector('[data-prod-nativo]');
        this.opcoes.hidden = false;
        if (nativo) nativo.hidden = true;

        this.el = {
          cheio: this.querySelector('[data-prod-cheio]'),
          valor: this.querySelector('[data-prod-valor]'),
          pix: this.querySelector('[data-prod-pix]'),
          linhaParcela: this.querySelector('[data-prod-parcela-linha]'),
          parcela: this.querySelector('[data-prod-parcela]'),
          cta: this.querySelector('[data-prod-cta]'),
          rotCta: this.querySelector('[data-prod-cta-rot]'),
          icoComprar: this.querySelector('.s-prod__ico-comprar'),
          icoReservar: this.querySelector('.s-prod__ico-reservar'),
          nota: this.querySelector('[data-prod-nota]'),
          previsao: this.querySelector('[data-prod-previsao]'),
          tarja: this.querySelector('[data-prod-tarja]')
        };

        this.opcoes.addEventListener('change', function () { this.escolher(false); }.bind(this));
        this.escolher(true);
      }

      escolher(inicio) {
        var marcados = [];
        Array.prototype.forEach.call(this.opcoes.querySelectorAll('input:checked'), function (r) {
          marcados[Number(r.getAttribute('data-prod-pos')) - 1] = r.value;
        });
        // a combinacao e comparada posicao por posicao ("6 trackers" nao pode casar com "16 trackers")
        var achada = null;
        for (var k = 0; k < this.lista.length; k++) {
          var v = this.lista[k];
          var igual = v.opcoes.length === marcados.length;
          for (var p = 0; igual && p < v.opcoes.length; p++) {
            if (v.opcoes[p] !== marcados[p]) igual = false;
          }
          if (igual) { achada = v; break; }
        }
        this.aplicar(achada, inicio);
      }

      mostrar(el, sim) {
        if (el) el.toggleAttribute('hidden', !sim);
      }

      aplicar(v, inicio) {
        var e = this.el;
        var cta = e.cta;
        if (!cta) return;

        if (!v) {
          cta.disabled = true;
          cta.setAttribute('aria-disabled', 'true');
          ['data-nt-reserva', 'data-nt-produto', 'data-nt-titulo', 'data-nt-variante'].forEach(function (a) { cta.removeAttribute(a); });
          if (e.rotCta) e.rotCta.textContent = this.rot.combo;
          this.mostrar(e.icoComprar, false);
          this.mostrar(e.icoReservar, false);
          this.mostrar(e.nota, false);
          this.mostrar(e.previsao, false);
          return;
        }

        this.campo.value = String(v.id);
        if (e.valor) e.valor.classList.toggle('s-prod__valor--breve', !!v.zero);

        if (v.zero) {
          if (e.valor) e.valor.textContent = this.rot.breve;
          this.mostrar(e.cheio, false);
          this.mostrar(e.pix, false);
          this.mostrar(e.linhaParcela, false);
        } else {
          if (e.valor) e.valor.textContent = v.pix || v.cheio;
          if (e.cheio) e.cheio.textContent = v.cheio;
          this.mostrar(e.cheio, !!v.pix);
          this.mostrar(e.pix, !!v.pix);
          if (e.parcela) e.parcela.textContent = v.parcela;
          this.mostrar(e.linhaParcela, true);
        }

        cta.disabled = false;
        cta.removeAttribute('aria-disabled');
        if (v.disp) {
          ['data-nt-reserva', 'data-nt-produto', 'data-nt-titulo', 'data-nt-variante'].forEach(function (a) { cta.removeAttribute(a); });
          if (e.rotCta) e.rotCta.textContent = this.rot.comprar;
          if (e.tarja) e.tarja.textContent = this.rot.escolha;
        } else {
          // sem estoque o botao abre o modal de reserva (snippets/nt-reserva.liquid) com a variante escolhida
          cta.setAttribute('data-nt-reserva', '');
          cta.setAttribute('data-nt-produto', this.getAttribute('data-produto') || '');
          cta.setAttribute('data-nt-titulo', this.getAttribute('data-titulo') || '');
          cta.setAttribute('data-nt-variante', v.titulo);
          if (e.rotCta) e.rotCta.textContent = this.rot.reservar;
          if (e.tarja) e.tarja.textContent = this.rot.estado;
        }
        this.mostrar(e.icoComprar, v.disp);
        this.mostrar(e.icoReservar, !v.disp);
        this.mostrar(e.nota, !v.disp);
        this.mostrar(e.previsao, !v.disp);

        if (v.foto) this.irParaFoto(v.foto, inicio);

        if (!inicio && window.history && history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          history.replaceState(history.state, '', url.toString());
        }
      }
    }
  );
})();
